import './styles.scss'
import React from 'react'
import { getStaticImage } from 'utils/statics'

const Index = (props) => {
  const { onHide, children, overlay = true, confirmationDialog, className, header = '' } = props

  return (
    <div className={`side-popup-settings ${className ? className : ''}`}>
      {overlay && <div className='side-popup-settings-overlay' onClick={onHide} />}
      {confirmationDialog && <div className='side-popup-settings-confirmation'>{confirmationDialog}</div>}
      <div className='side-popup-settings-container px-sm-5'>
        {/* <div className={`side-popup-settings-header container ${backButton ? 'with-back' : ''}`}>
          O
          {backButton ? (
            <i className='fa fa-chevron-left' onClick={onHide} />
          ) : (
            closeButton &&
            <span className='close' onClick={onHide}>
              &times;
            </span>
          )}
        </div> */}
        <div className='side-popup-settings-header'>
          <h1>{header}</h1>
          <span onClick={onHide}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>

        <div className='side-popup-settings-body container'>{children}</div>
      </div>
    </div>
  )
}

export default Index
